<section>

    <article class="card container-fluid">
        <h2 class="card-header text-center font-weight-bold text-uppercase py-4">All Client Properties</h2>

        <!-- Header -->
        <article class="table-header">
          <!-- Toolbar -->
          <div class="toolbar">
            <!-- Copy GeoJSON Link -->
            <button type="button" class="dt-button" (click)="copyGeoJsonLink()">
              <span>Copy GeoJSON Link</span>
              <img class="arcgis-logo ml-2" src="/assets/arcgis-globe-icon.png" height="23">
            </button>

            <!-- Copy GeoRSS Link -->
            <button type="button" class="dt-button" (click)="copyGeoRssLink()">
              <span>Copy GeoRSS Link</span>
              <mdb-icon class="rss-icon ml-1 text-danger" fas icon="rss-square"></mdb-icon>
            </button>
          </div>
        </article>

        <!-- Table -->
        <div class="card-body" style="overflow-x:auto;">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>Entry Date</th>
                        <th>Is Rented?</th>
                        <th>Rent Amount</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>ZipCode</th>
                        <th>Unit #</th>
                        <th>Bedrooms</th>
                        <th>Bathrooms</th>
                        <th>Renter First Name</th>
                        <th>Renter Last Name</th>
                        <th>Renter Email</th>
                        <th>Renter Phone</th>
                        <th>Owner Name</th>
                        <th>Manager Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Last Modified</th>
                        <th>Last Modified By</th>
                        <th>Move In Checklist Completed</th>
                        <th>Attachments</th>
                        <th>Edit/Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let property of allProperties">
                        <td class="td-issues">
                          <div class="wrapper">
                            <mdb-icon *ngIf="duplicatesFoundBy(property) > 0" fas icon="exclamation-triangle" class="text-warning icon-duplicates"
                              [matTooltip]="duplicatesTooltip(property)" matTooltipPosition="above">
                            </mdb-icon>
                          </div>
                        </td>
                        <td>
                          <span *ngIf="duplicatesFoundBy(property) > 0">Duplicate</span>
                        </td>
                        <td class="text-nowrap" [attr.data-sort]="sortDate(property.entryDate)">{{ property.entryDate | date }}</td>
                        <td>{{ property.isRented ? 'Yes' : 'No' }}</td>
                        <td>{{ property.rentAmount | currency: property.rentCurrency:'symbol':'1.0-2' }}</td>
                        <td>{{ property.address }}</td>
                        <td>{{ property.city }}</td>
                        <td>{{ property.zipCode }}</td>
                        <td>{{ property.unitNumber }}</td>
                        <td>{{ property.bedrooms }}</td>
                        <td>{{ property.bathrooms }}</td>
                        <td>{{ property.user?.firstName }}</td>
                        <td>{{ property.user?.lastName }}</td>
                        <td>{{ property.user?.email }}</td>
                        <td>{{ property.user?.phone }}</td>
                        <td>{{ property.ownerName }}</td>
                        <td>{{ property.managerName }}</td>
                        <td>{{ property.contactPhone }}</td>
                        <td>{{ property.email }}</td>
                        <td>{{ property.latitude }}</td>
                        <td>{{ property.longitude }}</td>
                        <td class="td-lastmodified">{{ property.lastUpdated | date:'medium' }}</td>
                        <td class="td-lastmodifiedby">{{ property.lastUpdatedBy }}</td>
                        <td>{{ property.isMoveInInspectionChecklistCompleted ? 'Yes' : 'No' }}</td>
                        <td>{{ property.files?.length || 0 }}</td>
                        <td class="td-actions">
                            <!-- Edit -->
                            <button type="button" class="mr-2" (click)="editProperty(property)"><mdb-icon fas icon="pen"></mdb-icon></button>

                            <!-- Checklist -->
                            <a class="mr-2" *ngIf="property.isRented || property.moveInInspectionChecklistCompletedID"
                              [routerLink]="['./condition-checklist']" [queryParams]="{ propertyid: property._id }">
                              <button type="button"><mdb-icon fas icon="clipboard-list"></mdb-icon></button>
                            </a>

                            <!-- Files -->
                            <a class="mr-2" [routerLink]="['./files']" [queryParams]="{ propertyid: property._id }">
                              <button type="button"><mdb-icon fas icon="paperclip"></mdb-icon></button>
                            </a>

                            <!-- Delete -->
                            <button type="button" class="mr-2 btn-danger" (click)="deleteProperty(property)"><mdb-icon fas icon="trash"></mdb-icon></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>
</section>
